import mixpanel from 'mixpanel-browser';
import TagManager from 'react-gtm-module';

import { IAuth } from '@/modules/auth/types';

/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/*                This file should have all analaytics configs                */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */

/* ------ Make sure to add their keys inside enviroment variables 
        (we added it in production only to collect analytics from only production) ------ */

export const initGTM = () => {
  if (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER) {
    TagManager.initialize({
      gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER,
    });
  }
};

export const initMixpanel = () => {
  if (process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
    mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN);
  }
};
interface IAdditionalDataSchema<T> {
  [key: string]: T;
}
export const trackMixpanelEvent = <T>(
  eventName: string,
  user: IAuth.IUser | null,
  additionalInfo?: IAdditionalDataSchema<T>
) => {
  if (process.env.NEXT_PUBLIC_MIXPANEL_TOKEN)
    if (user) {
      mixpanel.track(eventName, {
        distinct_id: user.companyId,
        id: user.id,
        name: user.barrelName,
        phoneNumber: user.phoneNumber,
        email: user.email,
        gender: user.gender,
        company: user.company?.name,
        jobTitle: user.jobTitle,
        isEmailVerified: user.isEmailVerified,
      });
    } else if (additionalInfo) {
      mixpanel.track(eventName, additionalInfo);
    }
};

export interface DataLayer {
  event?: string;
  form_name?: string;
  pathname?: string;
  form_data?: object;
  userName?: string;
  companyId?: number;
}

export const trackGAEvent = (dataLayer: DataLayer) => {
  if (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'signup_form_submit',
        form_name: 'Signup Form Aydi Eye',
        form_location: dataLayer.pathname,
        form_data: dataLayer.form_data,
        userName: dataLayer.userName,
        companyId: dataLayer.companyId || '',
      },
    });
  }
};

export function identifyMixPanelUser(userInfo: IAuth.IUser) {
  if (!userInfo || !userInfo.companyId) return;
  if (process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
    mixpanel.identify(String(userInfo.companyId));
    mixpanel.people.set({
      distinct_id: userInfo.company,
      $email: userInfo.email,
      $name: userInfo.company?.name,
    });
  }
}
